import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbSeparator,
  BreadcrumbPage,
} from "@/components/ui/breadcrumb";
import { Badge } from "@/components/ui/badge";
import { useTranslations } from "next-intl";

export function HeaderBreadcrumbs() {
  const t = useTranslations("layout30");

  return (
    <div className="flex flex-row items-center flex-wrap gap-1">
      <Breadcrumb aria-label={t("breadcrumb")}>
        <BreadcrumbList>
          <BreadcrumbSeparator className="text-xs text-muted-foreground px-1.5">
            {"/"}
          </BreadcrumbSeparator>

          <BreadcrumbItem>
            <BreadcrumbPage>{t("dashboard.title")}</BreadcrumbPage>
          </BreadcrumbItem>

          <BreadcrumbItem>
            <Badge variant="secondary" size="sm">
              {t("phaseValue")}
            </Badge>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
}
